export default __webpack_public_path__ + "static/media/send.17fa8280.svg";